import Vue from 'vue'

export const setStateItem = name => (state, data) =>
  Vue.set(state, name, data)

export const parseJSON = (json) => {
  try {
    return JSON.parse(json)
  } catch {
    console.warn('Invalid user data value.')
  }
}
